import React from 'react';
import ReportFrame from '../ReportFrame';

export default class UnbilledAR extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    // const reportParams = {
    //   RevenuePeriod: '202307',
    //   AsOfDate: '10/25/2023 12:00:00 AM',
    //   OfficeId: '9',
    // };
    const reportParams = {};
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          reportName='Unbilled AR'
          reportParams={reportParams}
          id='unbilledar'
          name='unbilledAR'
          title='Unbilled AR'
        />
      </div>
    );
  }
}
